/* eslint-disable max-len */
import React from 'react';
function CourseCatalogue() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 4H3C1.9 4 1 4.9 1 6V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V6C23 4.9 22.1 4 21 4ZM3 19V5.99999H11V19H3ZM13 19H21V5.99999H13V19ZM15 9.5H19V11H15V9.5ZM15 12H19V13.5H15V12ZM19 14.5H15V16H19V14.5ZM9 9.5H5V11H9V9.5ZM9 12H5V13.5H9V12ZM5 14.5H9V16H5V14.5Z" })));
}
export default CourseCatalogue;
